import {
  Map as ImmutableMap,
} from 'immutable';

import {
  generateVariantPropertyAvailabilityMap,
  generateVariantMap,
  generateInitialVariantPropertySelectionMap,
  updateVariantPropertyAvailabilityMap,
  updateSelectedVariantPropertyIndexMap,
} from '../../modules/cart/cartUtils';

function generateDefaultInitialCartState() {
  return {
    cartProductMap: ImmutableMap(),
    cartCandidateProduct: null,
    cartCandidateVariantPropertyAvailabilityMap: null,
    cartCandidateVariantMap: null,
    cartCandidateVariantPropertySelectionMap: ImmutableMap(),
    cartCandidateSelectedVariantPropertyIndexMap: ImmutableMap(),
    addToCartState: {productId: null, state: null},
  };
}

function cartReducer(state = generateDefaultInitialCartState(),
                     action) {
  let newState;

  switch (action.type) {
    case 'SET_CART_CANDIDATE_PRODUCT': {
      const {cartCandidateProduct} = action.payload;
      let updatedMaps;

      if (cartCandidateProduct.isSplitted) {
        updatedMaps = {};
      } else {
        const cartCandidateVariantPropertySelectionMap = generateInitialVariantPropertySelectionMap(
          cartCandidateProduct.allVariants,
        );
        const cartCandidateVariantMap = generateVariantMap(
          cartCandidateProduct.allVariants,
        );
        const cartCandidateVariantPropertyAvailabilityMap = updateVariantPropertyAvailabilityMap(
          generateVariantPropertyAvailabilityMap(
            cartCandidateProduct.allVariants,
          ),
          cartCandidateVariantPropertySelectionMap,
          cartCandidateVariantMap
        );
        const cartCandidateSelectedVariantPropertyIndexMap = updateSelectedVariantPropertyIndexMap(
          cartCandidateVariantPropertySelectionMap,
          cartCandidateVariantPropertyAvailabilityMap
        );

        updatedMaps = {
          cartCandidateVariantPropertyAvailabilityMap,
          cartCandidateVariantPropertySelectionMap,
          cartCandidateVariantMap,
          cartCandidateSelectedVariantPropertyIndexMap,
        };
      }

      newState = {
        ...state,
        cartCandidateProduct,
        ...updatedMaps,
      };

      break;
    }

    case 'GET_SPLIT_PRODUCT_VARIANTS_FULFILLED': {
      const allVariants = action.payload.response.data.data;
      let variantArray;

      if (allVariants.length > 0) {
        variantArray = allVariants;
      } else {
        variantArray = state.cartCandidateProduct.allVariants;
      }

      const cartCandidateVariantPropertySelectionMap = generateInitialVariantPropertySelectionMap(
        variantArray,
      );
      const cartCandidateVariantMap = generateVariantMap(
        variantArray,
      );
      const cartCandidateVariantPropertyAvailabilityMap = updateVariantPropertyAvailabilityMap(
        generateVariantPropertyAvailabilityMap(
          variantArray,
        ),
        cartCandidateVariantPropertySelectionMap,
        cartCandidateVariantMap
      );
      const cartCandidateSelectedVariantPropertyIndexMap = updateSelectedVariantPropertyIndexMap(
        cartCandidateVariantPropertySelectionMap,
        cartCandidateVariantPropertyAvailabilityMap
      );

      newState = {
        ...state,
        cartCandidateVariantPropertyAvailabilityMap,
        cartCandidateVariantPropertySelectionMap,
        cartCandidateVariantMap,
        cartCandidateSelectedVariantPropertyIndexMap,
      };

      break;
    }

    case 'ADD_TO_CART_FULFILLED': {
      const {item} = action.triggerPayload;

      newState = {
        ...state,
        cartProductMap: state.cartProductMap.set(
          item.sku,
          item,
        ),
      };

      break;
    }

    case 'UPDATE_ACTIVE_VARIANT_SELECTION': {
      const {
        cartCandidateVariantPropertySelectionMap: variantPropertySelectionMap,
      } = state;
      const {variantPropertySelection} = action.payload;
      const newVariantPropertySelectionMap = variantPropertySelectionMap.set(
        variantPropertySelection.variantProperty.name,
        variantPropertySelection
      );
      const cartCandidateVariantPropertyAvailabilityMap = updateVariantPropertyAvailabilityMap(
        state.cartCandidateVariantPropertyAvailabilityMap,
        newVariantPropertySelectionMap,
        state.cartCandidateVariantMap,
      );
      const cartCandidateSelectedVariantPropertyIndexMap = updateSelectedVariantPropertyIndexMap(
        newVariantPropertySelectionMap,
        cartCandidateVariantPropertyAvailabilityMap
      );

      newState = {
        ...state,
        cartCandidateVariantPropertySelectionMap: newVariantPropertySelectionMap,
        cartCandidateVariantPropertyAvailabilityMap,
        cartCandidateSelectedVariantPropertyIndexMap,
      };

      break;
    }

    case 'RESET_ADD_TO_CART_MODAL_STATE': {
      newState = {
        ...state,
        cartCandidateProduct: null,
        cartCandidateVariantPropertyAvailabilityMap: null,
        cartCandidateVariantMap: null,
        cartCandidateVariantPropertySelectionMap: ImmutableMap(),
        cartCandidateSelectedVariantPropertyIndexMap: ImmutableMap(),
      };

      break;
    }

    case 'ADD_TO_CART_STATE': {
      newState = {
        ...state,
        addToCartState: {
          productId: action.payload.productId,
          state: action.payload.state,
        },
      };

      break;
    }

    default:
      newState = state;
  }

  return newState;
}

export default cartReducer;
export {generateDefaultInitialCartState};
